<template>
    <label
        :class="{ thin, disabled, checked: inverse ? !value : value, 'no-left' : !left }"
        class="switch-field"
        :style="{ '--transform': thin ? 'translateX(16px)' : `translateX(${translateX}px)` }"
        @click.prevent="toggle"
    >
        <slot v-if="left" />
        <div class="switch" />
        <input
            :value="inverse ? !value : value"
            :checked="inverse ? !value : value"
            :disabled="disabled"
            type="checkbox"
        />
        <slot v-if="!left" />
    </label>
</template>

<script>
export default {
    name: 'SwitchField',
    props: {
        value: { type: Boolean, default: false },
        inverse: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        thin: { type: Boolean, default: false },
        left: { type: Boolean, default: false },
        translateX: { type: String, default: '24' }
    },
    emits: ['update:value'],
    slots: ['default'],
    methods: {
        toggle() {
            if (!this.disabled) this.$emit('update:value', !this.value);
        }
    }
};
</script>

<style lang="less" scoped>

.switch-field {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0;
    height: auto;
    min-height: 32px;
    font-weight: normal;
    &.disabled {
        cursor: default;
        color: var(--steel);
       .switch { opacity: 0.2; }
    }
    input[type="checkbox"] {
        position: absolute;
        appearance: none;
        &:disabled { cursor: default; }
    }
    .switch {
        position: relative;
        display: flex;
        align-items: center;
        margin: 0 8px;
        &::before, &::after {
            content: "";
            display: block;
            transition: var(--smooth);
            border-radius: 16px;
        }
        &::before {
            background-color: var(--anchor);
            width: 56px;
            height: 32px;
            box-shadow:
                inset 0px 5px 20px rgba(0, 0, 0, 0.04),
                inset 0px 1px 6px rgba(0, 0, 0, 0.04),
                inset 0px 0px 1px rgba(0, 0, 0, 0.04);
        }
        &::after {
            position: absolute;
            left: 4px;
            width: 24px;
            height: 24px;
            background: #FFF;
            box-shadow: var(--shadow-base);
        }
    }
    &.checked .switch {
        &::after { transform: var(--transform); }
        &::before {
            background-color: var(--success);
            box-shadow: none;
        }
    }
    &.no-left .switch {
        margin: 0 8px 0 0;
    }
    &.thin {
        height: auto;
        min-height: unset;
        .switch {
            &::before {
                width: 32px;
                height: 4px;
                box-shadow: none;
                background-color: var(--anchor);
            }
            &::after {
                left: 0;
                width: 16px;
                height: 16px;
                background: var(--steel);
            }
        }
        &.checked .switch {
            &::after { background-color: var(--success); }
            &::before { background-color: var(--success-shade-1); }
        }
    }
}
</style>
